export default "__VITE_ASSET__DoY1xX0V__"